import Login from "../components/Login";

const LoginPage = () => {
  return <div className='center'>
      <Login/>
  </div>
}

export default LoginPage